import { OnInit } from '@angular/core';

export class RAWidgetConfigContainer implements OnInit {
  ngOnInit(){
    
  }
  configLaunchEventHandler(e){

  }
}
